import { defineAction } from '~/prix'
import actionJson from './waterSourceDocumentFetch.action.json' with { type: 'json' }
import { waterSourceDocumentObject } from '../waterSourceDocumentObject'
import { z } from 'zod'

const definition = defineAction({
  ...actionJson,
  input: z.object({
    id: waterSourceDocumentObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: waterSourceDocumentObject,
})

export default definition
